import classNames from 'classnames'
import React from 'react'
import {isDateTbd} from '@wix/wix-events-commons-statics'
import {useEventDateInformation} from '../../../../../../../../commons/hooks/dates'
import sd from '../../../common/mobile-layout.scss'
import {useVisibilityStyles} from '../../../../../hooks/use-visibility-styles'
import s from './date.scss'

export const Date = ({event}: {event: wix.events.Event}) => {
  const {
    allBreakpoints: {isListDateEnabled},
  } = useVisibilityStyles()
  const {shortStartDate} = useEventDateInformation(event.id)
  const dateTbd = isDateTbd(event)

  if (!isListDateEnabled()) {
    return null
  }

  return (
    <div
      className={classNames(s.date, sd.eventNameFont, sd.eventNameColor)}
      data-hook={dateTbd ? 'ev-date-tbd' : 'ev-date'}
    >
      {shortStartDate}
    </div>
  )
}
